<section class="error-page" role="alert">
  <i class="error-page__icon cds-icon-outlined-alert-circle" aria-hidden="true"></i>

  <h2 class="error-page__title">Não foi possível carregar suas informações</h2>

  <p class="error-page__message">
    Sua sessão não pôde ser validada. Atualize a página para tentar novamente. Se o problema
    continuar, entre em contato com o suporte.
  </p>
</section>
